/**
 * Gestion du bouton "Installer l'application" (PWA)
 *
 * - Android / Chrome desktop : capture l'événement `beforeinstallprompt`
 *   et déclenche l'invite d'installation native au clic.
 * - iOS / Safari : pas d'invite native, on affiche les instructions
 *   (« Partager » → « Sur l'écran d'accueil »).
 * - App déjà installée (mode standalone) : le bouton reste masqué.
 */
(function () {
    'use strict';

    const BTN_SELECTOR = '#pwa-install-btn';
    const IOS_HELP_SELECTOR = '#pwa-ios-help';

    // L'app tourne-t-elle déjà en mode installé ?
    function isStandalone() {
        return (
            window.matchMedia('(display-mode: standalone)').matches ||
            window.navigator.standalone === true
        );
    }

    function isIOS() {
        return (
            /iphone|ipad|ipod/i.test(window.navigator.userAgent) &&
            !window.MSStream
        );
    }

    document.addEventListener('DOMContentLoaded', function () {
        const btn = document.querySelector(BTN_SELECTOR);
        if (!btn) return;

        // On bascule entre `hidden` et `inline-flex` : les deux classes ne
        // doivent jamais coexister sur l'élément (sinon `inline-flex`, déclaré
        // après `hidden` dans Tailwind, l'emporterait et le bouton resterait
        // toujours visible).
        function showBtn() {
            btn.classList.remove('hidden');
            btn.classList.add('inline-flex');
        }
        function hideBtn() {
            btn.classList.add('hidden');
            btn.classList.remove('inline-flex');
        }

        // Déjà installée : rien à proposer.
        if (isStandalone()) return;

        let deferredPrompt = null;

        // Android / Chrome : l'invite native est disponible.
        window.addEventListener('beforeinstallprompt', function (e) {
            e.preventDefault();
            deferredPrompt = e;
            showBtn();
        });

        // iOS : pas de `beforeinstallprompt`, on affiche quand même le bouton
        // pour ouvrir les instructions manuelles.
        if (isIOS()) {
            showBtn();
        }

        btn.addEventListener('click', async function () {
            if (deferredPrompt) {
                deferredPrompt.prompt();
                await deferredPrompt.userChoice;
                deferredPrompt = null;
                hideBtn();
                return;
            }

            // iOS (ou navigateur sans invite native) : afficher les instructions.
            const help = document.querySelector(IOS_HELP_SELECTOR);
            if (help) {
                help.classList.toggle('hidden');
            }
        });

        // Masquer le bouton une fois l'installation effectuée.
        window.addEventListener('appinstalled', function () {
            hideBtn();
            const help = document.querySelector(IOS_HELP_SELECTOR);
            if (help) help.classList.add('hidden');
        });
    });
})();
